export default "__VITE_ASSET__B1z66lKG__"